import {Component} from '@angular/core';
import {Report, ReportScheduleResolution, TimeResolution} from "@flowmaps-com/flowmaps-typescriptmodels";
import {cloneDeep} from "lodash";
import {Handler} from "../../../common/handler";
import {View} from "../../../common/view";

@Component({
    selector: 'app-quarterly-report',
    templateUrl: './quarterly-report.component.html'
})
@Handler()
export class QuarterlyReportComponent extends View {
    report: Report;

    constructor() {
        super();
        this.report = cloneDeep(QuarterlyReportComponent.defaultReport);
    }

    static defaultReport: Report = (<Report>{
        info: {
            name: "Default",
            query: {
                range: {
                    resolution: ReportScheduleResolution.year,
                    value: 0
                },
                resolution: TimeResolution.month
            }
        }
    });
}
